<script>
/**
 * Imports
 */
import SignupPackages from "./../packages/SignupPackages.vue";
import SignupPackagesSummary from "./../packages/SignupPackagesSummary.vue";
import SignupPackagesPayments from "./../packages/SignupPackagesPayments.vue";

/**
 * Component: Sections: Packages
 *
 * The component used for displaying the Packages section
 * on signup form. The fields and the data is configured
 * from wp-admin and Sections CPT.
 *
 * @author PH
 */
export default {
  data: function() {
    return {
      l18n: {},
      settings: {}
    };
  },

  created: function() {
    this.l18n = this.getData("l18n");
    this.settings = this.getData("settings");
  },

  computed: {
    valid: {
      get() {
        return this.$store.getters.getSectionData("packages", "valid");
      },
      set(value) {
        this.$store.commit("updateSection", {
          section: "packages",
          values: {
            valid: value
          }
        });
      }
    },

    active() {
      return this.$store.getters.getSectionData("packages", "active");
    },

    next() {
      return this.$store.getters.getSectionData("packages", "next");
    },

    introduction() {
      const introduction = this.$store.getters.getSectionData("packages", "introduction");;
      return introduction ? introduction : 'Recommended packages, create your own package and ala carte options available.';
    },

    disclaimer() {
      if (this.settings && this.settings.disclaimer) {
        return this.settings.disclaimer;
      }
      return null;
    },

    hideSummary() {
      if (this.settings && this.settings.hideSummary) {
        return this.settings.hideSummary;
      }
      return null;
    },

    submitLabel() {
      if (this.settings.submitLabel) {
        return this.settings.submitLabel;
      }
      return this.l18n.submit.continue;
    }
  },

  methods: {
    /**
     * Submit: Form
     *
     * @author PH
     * @return void
     */
    submitForm: function(e) {
      e.preventDefault();

      let valid = false;
      let section = this.$store.getters.getSection("packages");

      if (section && section.fields) {
        section.fields.forEach(field => {
          if (true === field.value) {
            valid = true;
          }
        });
      }

      this.valid = valid;

      if (this.valid) {
        this.$store.commit("changeSection", {
          id: this.next
        });
      }
    },

    /**
     * Get: Data
     *
     * @author PH
     * @return string|bool
     */
    getData: function(property) {
      if (property) {
        return this.$store.getters.getSectionData("packages", property);
      }
      return false;
    },

    /**
     * Get: Group
     *
     * Function filters all the fields and gets
     * fields which are needed for the specific group.
     *
     * @author PH
     * @return array
     */
    getFields(group) {
      return this.getData("fields").filter(field => {
        return field.group === group;
      });
    }
  },

  components: { SignupPackages, SignupPackagesSummary, SignupPackagesPayments }
};
</script>

<template>
  <div
    class="signup-section signup-section-packages"
    :class="{ valid: valid === true, invalid: valid === false }"
    v-if="active"
  >
    <form action method="POST" @submit="submitForm">
      <div class="signup-section__header">
        <h2>{{getData('header')}}</h2>
        <p v-if="introduction" v-html="introduction"></p>
      </div>

      <div class="signup-section__content">
        <form action="#" method="POST" @submit="submitForm">
          <signup-packages
            v-bind:groups="getData('groups')"
            v-bind:fields="getData('fields')"
            v-bind:settings="settings"
          ></signup-packages>

          <signup-packages-payments
            v-if="settings.payments"
            v-bind:l18n="l18n.payments"
            v-bind:selected="settings.payments.selected"
            v-bind:required="settings.payments.required"
            v-bind:methods="settings.payments.methods"
          ></signup-packages-payments>


          <signup-packages-summary
            v-if="! settings.hideSummary"
            v-bind:groups="getData('groups')"
            v-bind:fields="getData('fields')"
            v-bind:settings="settings"
          ></signup-packages-summary>
        </form>
      </div>

      <div class="signup-section__disclaimer" v-if="disclaimer" v-html="disclaimer"></div>

      <div class="signup-section__footer">
        <div class="signup-section__notifications" v-if="valid === false">
          <p>{{l18n.submit.error}}</p>
        </div>
        <div class="signup-section__submit">
          <button type="submit">{{submitLabel}}</button>
        </div>
      </div>
    </form>
  </div>
</template>

